const ORDER_KEY = 'edi_demo_orders'
const STORAGE_VERSION_KEY = 'web_order_storage_version'

if (sessionStorage.getItem(STORAGE_VERSION_KEY) !== '2') {
  sessionStorage.removeItem(ORDER_KEY)
  sessionStorage.setItem(STORAGE_VERSION_KEY, '2')
}

const clone = value => JSON.parse(JSON.stringify(value))
const read = (key, fallback) => {
  try {
    const value = sessionStorage.getItem(key)
    return value ? JSON.parse(value) : clone(fallback)
  } catch (e) {
    return clone(fallback)
  }
}
const write = (key, value) => sessionStorage.setItem(key, JSON.stringify(value))

export function createDemoOrder({ company, address, cart, total, deliveryFee, totalNum, date, start, end }) {
  const id = Date.now()
  const order = {
    id, companyId: company.id, tcompanyName: company.companyName,
    orderType: company.type, status: 0, statusStr: '待付款',
    total: Number(total || 0), deliveryFee: Number(deliveryFee || 0),
    totalNum: Number(totalNum || 0), taddress: clone(address),
    submitTime: new Date().toLocaleString('zh-CN', { hour12: false }),
    date: date || new Date().toLocaleDateString('zh-CN'), start: start || '尽快送达', end: end || '',
    itemList: cart.map(({ item, quantity }) => ({
      itemId: item.id, itemNum: quantity,
      selectedSpecifications: '', info: clone(item)
    }))
  }
  const orders = read(ORDER_KEY, [])
  orders.unshift(order)
  write(ORDER_KEY, orders)
  return clone(order)
}

export function getDemoOrder(id) {
  return clone(read(ORDER_KEY, []).find(item => String(item.id) === String(id)) || null)
}

export function listDemoOrders(start = -1, end = -1) {
  return clone(read(ORDER_KEY, []).filter(item => start === -1 || (item.status >= start && item.status <= end)))
}

export function payDemoOrder(id) {
  const orders = read(ORDER_KEY, [])
  const order = orders.find(item => String(item.id) === String(id))
  if (!order) return null
  order.status = 2
  order.statusStr = '支付成功，商家待接单'
  order.payTime = new Date().toLocaleString('zh-CN', { hour12: false })
  write(ORDER_KEY, orders)
  return clone(order)
}

export function cancelDemoOrder(id) {
  const orders = read(ORDER_KEY, [])
  const order = orders.find(item => String(item.id) === String(id))
  if (!order) return null
  order.status = 7
  order.statusStr = '已取消'
  write(ORDER_KEY, orders)
  return clone(order)
}

export function isDemoOrder(id) {
  return Boolean(getDemoOrder(id))
}

export function confirmDemoOrder(id) {
  const orders = read(ORDER_KEY, [])
  const order = orders.find(item => String(item.id) === String(id))
  if (!order || Number(order.status) !== 5) return null
  order.status = 6; order.statusStr = '待评价'; write(ORDER_KEY, orders)
  return clone(order)
}
